export enum BackgroundColor {
  WHITE = '#ffffff',
  YELLOW = '#ffdd00',
  BLACK = '#000000',
}
